module.exports = {
          srcSet: __webpack_public_path__ + "b72cd3bc.jpg"+" 700w"+","+__webpack_public_path__ + "c6bf1206.jpg"+" 1400w"+","+__webpack_public_path__ + "894a3828.jpg"+" 2048w",
          images:[ {path: __webpack_public_path__ + "b72cd3bc.jpg",width: 700,height: 467},{path: __webpack_public_path__ + "c6bf1206.jpg",width: 1400,height: 933},{path: __webpack_public_path__ + "894a3828.jpg",width: 2048,height: 1365}],
          src: __webpack_public_path__ + "b72cd3bc.jpg",
          toString:function(){return __webpack_public_path__ + "b72cd3bc.jpg"},
          
          width: 700,
          height: 467
        }